export function selectedGroupReducer(state: any = null, action: { type: string, payload: any }) {
    let newState = state;
    if (action && action.type) {
        switch (action.type) {
            case 'GROUP_SELECTED':
                newState = action.payload;
                break;
        }
    }
    return newState;
}